import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TextEditorComponent, InfoData } from '../../../shared/public-api';

@Component({
  selector: 'admin-info-section',
  templateUrl: './info-section.component.html',
  styleUrls: ['./info-section.component.scss'],
  imports: [CommonModule, FormsModule, TextEditorComponent],
})
export class InfoSectionComponent implements OnInit {
  @Input() sectionData: InfoData;
  @Output() sectionDataChange = new EventEmitter<any>();

  ngOnInit(): void {
    if (!this.sectionData) {
      this.sectionData = new InfoData();
    }
  }
}
